
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { piquestSubjectWebservice } from '@/webservices/piquestSubject';
import { PiquestSubject } from '@/models/piquestSubject';
import ConfirmModal from '@/components/prine/ConfirmModal.vue';
import * as R from 'ramda';

@Component({
    name: 'PiquestSubjectsList',
    components: {
        ConfirmModal,
    },
})
export default class PiquestSubjectsList extends Vue {
    private piquestSubjects: PiquestSubject[] = [];
    private selectedPiquestSubject: PiquestSubject = { id: 0, name: '', title: '' } as PiquestSubject;
    private newPiquestSubject: PiquestSubject = { id: 0, name: '', title: '' } as PiquestSubject;
    private isLoading: boolean = true;
    private displayStudents: boolean = false;
    private perPage: number = 20;
    private isSearching: boolean = false;
    private searchQuery: string = '';
    private isCreateModalActive: boolean = false;
    private isEditModalActive: boolean = false;
    private isConfirmModalActive: boolean = false;

    private mounted() {
        console.log('mounted PiquestSubjectsList');
        this.getAll();
    }

    private toggleCreateModal() {
        this.isCreateModalActive = !this.isCreateModalActive;
        this.newPiquestSubject = {
            id: 0,
            name: '',
            title: '',
        };
    }

    private toggleEditModal(piquestSubject: PiquestSubject = { id: 0, name: '', title: '' }) {
        this.isEditModalActive = !this.isEditModalActive;
        this.selectedPiquestSubject = JSON.parse(JSON.stringify(piquestSubject));
    }

    private toggleConfirmModal(answer: boolean = false) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer && !R.isNil(this.selectedPiquestSubject)) {
            this.remove(this.selectedPiquestSubject);
        }
    }

    private async getAll() {
        this.piquestSubjects = await piquestSubjectWebservice.getAll();
        this.isLoading = false;
    }

    private async store() {
        if (
            !R.isNil(this.newPiquestSubject) &&
            !R.isEmpty(this.newPiquestSubject.name) &&
            !R.isEmpty(this.newPiquestSubject.title)
        ) {
            this.isLoading = true;
            await piquestSubjectWebservice.store(this.newPiquestSubject);
            this.getAll();
            this.isLoading = false;
            this.$buefy.snackbar.open({
                duration: 3000,
                message: 'Stored ' + this.newPiquestSubject.title,
                type: 'is-success',
                position: 'is-bottom-right',
                queue: false,
            });

            this.newPiquestSubject = { id: 0, name: '', title: '' } as PiquestSubject;
            this.toggleCreateModal();
        }
    }

    private async update() {
        if (
            !R.isNil(this.selectedPiquestSubject) &&
            !R.isEmpty(this.selectedPiquestSubject.title) &&
            !R.isEmpty(this.selectedPiquestSubject.name)
        ) {
            this.isLoading = true;
            await piquestSubjectWebservice.update(this.selectedPiquestSubject);
            this.getAll();
            this.isLoading = false;
            this.$buefy.snackbar.open({
                duration: 3000,
                message: 'Updated ' + this.selectedPiquestSubject.title,
                type: 'is-success',
                position: 'is-bottom-right',
                queue: false,
            });
            this.toggleEditModal();
        }
    }

    private async remove(piquestSubject: PiquestSubject) {
        this.toggleEditModal();

        this.isLoading = true;
        await piquestSubjectWebservice.remove(piquestSubject);
        this.getAll();
        this.isLoading = false;

        this.$buefy.snackbar.open({
            duration: 3000,
            message: 'Removed ' + piquestSubject.title,
            type: 'is-danger',
            position: 'is-bottom-right',
            queue: false,
        });
    }
}
